import React from 'react';
import { SlugText } from '../Text/Text';
export function Slug({ children, ...rest }) {
    return React.createElement(SlugText, Object.assign({}, rest),
        "/",
        children);
}
